export default "__VITE_ASSET__BiRrh3HB__"